import Vue from 'vue';
import Vuex from 'vuex';
import { DpSentryAddBreadcrumb, DpNavigationModule as navigation } from '@docupet/component-library';
import * as notification from '@/store/modules/notification';
import * as order from '@/store/modules/order';
import * as user from '@/store/modules/user';
import * as petOwner from '@/store/modules/petOwner';
import * as product from '@/store/modules/product';

Vue.use(Vuex);

// Grab Initial state or create own for env
const initialState = window.__INITIAL_STATE__ || {
  locale: process.env.VUE_APP_LOCALE || 'en_US',
  token: process.env.VUE_APP_TOKEN || null,
  orderId: process.env.VUE_APP_ORDER_ID || null,
  cityId: process.env.VUE_APP_CITY_ID || null,
  membershipRemovalSurvey: false,
  automatedDiscounts: false,
};

initialState.baseUrl = window.BASE_URL || process.env.VUE_APP_BASE_URL;

export default new Vuex.Store({
  modules: {
    notification,
    order,
    user,
    petOwner,
    product,
    navigation,
  },
  state: initialState,
  getters: {
    getLocale: ({ locale }) => locale || window.__INITIAL_STATE__.locale || 'en_US',
    getOrderId: ({ orderId }) => orderId || window.__INITIAL_STATE__.orderId || null,
    getMembershipRemovalSurvey: ({ membershipRemovalSurvey }) => membershipRemovalSurvey || false,
    automatedDiscountsEnabled: ({ automatedDiscounts }) => automatedDiscounts === true,
    generateFullUrl:
      ({ baseUrl, locale }) =>
      (path) =>
        `${baseUrl}/${locale}${path || ''}`,
  },
  plugins: [
    (store) => {
      store.subscribeAction((action, state) =>
        DpSentryAddBreadcrumb('Action', 'info', action?.type || '', {
          ...state,
          token: null,
        })
      );
      store.subscribe((mutation) => DpSentryAddBreadcrumb('Mutation', 'info', mutation?.type || ''));
    },
  ],
});
